import React, { useRef, useEffect } from "react";
import { Carousel as NativeCarousel } from "@fancyapps/ui/dist/carousel.esm.js";

import "@fancyapps/ui/dist/carousel.css";

function ReactCarousel(props) {
  const wrapper = useRef(null);

  useEffect(() => {
    const items = props.items || [];
    const opts = props.options || {};

    console.log(items);
    opts.slides = [...items].map((val) => {
      return (
        { html: `<div class="carousel-inner carousel-inner-home"><a href="/realizzazioni/${val.id}"><span>${val.title.rendered}</span><img src="${val._embedded["wp:featuredmedia"]["0"].source_url}" /></a></div>` }
      )
    });

    const instance = new NativeCarousel(wrapper.current, opts);

    return () => {
      instance.destroy();
    };
  }, []);

  return <div className={`carousel ${props.class || ""}`} ref={wrapper}></div>;
}

export default ReactCarousel;
